import React from 'react';
import { motion } from 'framer-motion';
import './AboutUs.css';

const AboutUs = () => {


  const achievements = [
    {
      id: 1,
      icon: '🎯',
      title: '93% წარმატება',
      description: 'ჩვენი პროგნოზების საშუალო წარმატების მაჩვენებელი'
    },
    {
      id: 2,
      icon: '📊',
      title: '1000+ პროგნოზი',
      description: 'წარმატებით განხორციელებული პროგნოზების რაოდენობა'
    },
    {
      id: 3,
      icon: '⚽',
      title: '15+ ლიგა',
      description: 'ევროპისა და მსოფლიოს წამყვანი ლიგების ანალიზი'
    },
    {
      id: 4,
      icon: '🏆',
      title: '3+ წელი',
      description: 'წარმატებული მუშაობის გამოცდილება ბაზარზე'
    }
  ];

  const services = [
    {
      id: 1,
      icon: '📅',
      title: 'დღის პროგნოზი',
      description: 'ყოველდღიური ანალიზი და რეკომენდაციები მთავარი მატჩებისთვის',
      features: ['დეტალური ანალიზი', 'სტატისტიკური მონაცემები', 'ექსპერტული შეფასება']
    },
    {
      id: 3,
      icon: '🔴',
      title: 'ლაივ მონიტორინგი',
      description: 'რეალურ დროში მატჩების თვალყურება და ანალიზი',
      features: ['რეალურ დროში განახლება', 'ლაივ სტატისტიკა', 'მყისიერი შეტყობინებები']
    },
    {
      id: 4,
      icon: '📊',
      title: 'ისტორია და ანალიზი',
      description: 'ყველა წინა პროგნოზის დეტალური ისტორია და ანალიზი',
      features: ['სრული ისტორია', 'ფილტრაცია', 'სტატისტიკური ანალიზი']
    }
  ];

  return (
    <motion.div 
      className="about-us"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container">
        {/* Header */}
        <div className="page-header">
          <motion.h1 
            className="page-title"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            ჩვენს შესახებ 🏆
          </motion.h1>
          <motion.p 
            className="page-subtitle"
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            NTF - საქართველოს წამყვანი ფეხბურთის პროგნოზების პლატფორმა
          </motion.p>
        </div>

        {/* Mission Section */}
        <motion.section 
          className="mission-section"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <div className="mission-content">
            <div className="mission-icon">🎯</div>
            <h2 className="mission-title">ჩვენი მისია</h2>
            <p className="mission-text">
              NTF-ის მისიაა ქართველ ფეხბურთის მოყვარულებს მივაწოდოთ ყველაზე ზუსტი და 
              დეტალური პროგნოზები, რომლებიც დაფუძნებულია ღრმა ანალიზზე, სტატისტიკურ 
              მონაცემებზე და მრავალწლიან გამოცდილებაზე. ჩვენ ვცდილობთ გავხადოთ ფეხბურთის 
              ყურება უფრო საინტერესო და მომგებიანი.
            </p>
          </div>
        </motion.section>

        {/* Achievements */}
        <motion.section 
          className="achievements-section"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <h2 className="section-title">ჩვენი მიღწევები</h2>
          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <motion.div 
                key={achievement.id}
                className="achievement-card"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.6 + index * 0.1 }}
              >
                <div className="achievement-icon">{achievement.icon}</div>
                <h3 className="achievement-title">{achievement.title}</h3>
                <p className="achievement-description">{achievement.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>



        {/* Services Section */}
        <motion.section 
          className="services-section"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.9 }}
        >
          <h2 className="section-title">ჩვენი სერვისები</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <motion.div 
                key={service.id}
                className="service-card"
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 1.0 + index * 0.1 }}
              >
                <div className="service-header">
                  <div className="service-icon">{service.icon}</div>
                  <h3 className="service-title">{service.title}</h3>
                </div>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="service-feature">
                      <span className="feature-bullet">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </motion.section>


      </div>
    </motion.div>
  );
};

export default AboutUs;